<template>
  <div class="container">

    <administrative-dashboard v-if="userProfile.userRole == 'admin' && userProfile.active == true" />
    <teacher-dashboard v-if="userProfile.userRole == 'teacher' && userProfile.active == true" />
    <locked-account v-if="userProfile.active == false" />
    <add-codes v-if="addCodesComponent" />
    <batch-add-districts v-if="batchAddDistrictsComponent" />
    <batch-update-district-units v-if="batchUpdateDistrictUnits" />
    <update-unit-list v-if="updateUnitList" />
    <add-training v-if="addTraining"></add-training>
    <div class="dash-footer">
      <p>For technical support and to submit feedback, please email <a href="mailto: info@bcamsc.org" target="_blank">info@bcamsc.org.</a></p>
      <p class="copy">Copyright &copy; 2020-2026 Cereal City Science - All rights reserved. All digital materials provided through CCS Online, including but not limited to PDFs, Google Slides, presentations, worksheets, assessments, multimedia content, and other digital documents (collectively “Digital Materials”), are the exclusive intellectual property of Cereal City Science. Digital Materials are solely provided for educators using the Cereal City Science curriculum and may not be shared or distributed outside of authorized classroom use.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AdministrativeDashboard from './../components/admin/AdministrativeDashboard.vue'
import TeacherDashboard from './../components/dashboard/TeacherDashboard.vue'
import LockedAccount from './../components/dashboard/LockedAccount.vue'
import AddCodes from './../components/admin/AddCodes.vue'
import BatchAddDistricts from './../components/admin/BatchAddDistricts.vue'
import BatchUpdateDistrictUnits from './../components/admin/BatchUpdateDistrictUnits.vue'
import UpdateUnitList from './../components/admin/UpdateUnitList.vue'
import AddTraining from './../components/admin/AddTraining.vue'

export default {
  data() {
    return {
      addCodesComponent: false,
      batchAddDistrictsComponent: false,
      batchUpdateDistrictUnits: false,
      updateUnitList: false,
      addTraining: false
    }
  },
  components: {
    AdministrativeDashboard,
    TeacherDashboard,
    LockedAccount,
    AddCodes,
    BatchAddDistricts,
    BatchUpdateDistrictUnits,
    UpdateUnitList,
    AddTraining
  },
  computed: {
    ...mapState([ 'currentUser', 'userProfile' ])
  },
  mounted() {
    this.$store.commit('SET_DASHBOARD_VIEW','units')
  }
}
</script>

<style lang="css" scoped>
.copy {
  font-size: .7em;
}
</style>
